// extracted by mini-css-extract-plugin
module.exports = {"dropdownTitle":"articlepage_dropdownTitle__mUfB4","scenario":"articlepage_scenario__ajYRs","button":"articlepage_button__1QSsW"};